import {
    Edit,
    SimpleForm,
    TextInput,
    SelectInput,
    BooleanInput,
    required,
    email,
    TopToolbar,
    ListButton,
    ShowButton,
} from 'react-admin';

const UserEditActions = () => (
  <TopToolbar>
    <ListButton />
    <ShowButton />
  </TopToolbar>
);

export const UserEdit: React.FC = () => (
  <Edit actions={<UserEditActions />}>
    <SimpleForm>
      <TextInput type="email" source="email" validate={[required(), email()]} />
      <TextInput source="firstName" />
      <TextInput source="lastName" />
      <SelectInput
        source="role"
        choices={[
          { id: 'ADMIN', name: 'Admin' },
          { id: 'CUSTOMER', name: 'Customer' },
        ]}
        validate={[required()]}
      />
      <BooleanInput source="isActive" />
    </SimpleForm>
  </Edit>
);
